import React from 'react';

import { usePlaylist } from '../../../context';
import SelectCoursesAndPreview from './components/SelectCoursesAndPreview';

const PlaylistSelectCourse = () => {
  const {
    playlists: { selectedPlaylist: playlist },
    dialogs: {
      formStatus,
      setFormStatus,
      setOpenAddCoursesToPlaylist,
      updatePlaylistContentHandler,
    },
  } = usePlaylist();

  const onCloseHandler = () => {
    setOpenAddCoursesToPlaylist(false);
    setFormStatus(null);
  };

  const handleSubmit = (coursesSelected) => {
    updatePlaylistContentHandler(playlist, coursesSelected);
  };

  return (
    <SelectCoursesAndPreview
      formStatus={formStatus}
      handleSubmit={handleSubmit}
      onClose={onCloseHandler}
      playlist={playlist}
    />
  );
};

export default PlaylistSelectCourse;
